import { __makeTemplateObject } from "tslib";
import { css } from '../../../../foundation';
import { DividerInMenuStyle } from '../../MenuList/styles';
export var MenuStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), DividerInMenuStyle);
};
var templateObject_1;
